// extracted by mini-css-extract-plugin
export var author = "Quote-module--author--Al9ka";
export var left = "Quote-module--left--D091f";
export var quote = "Quote-module--quote--4pZXV";
export var quoteMarks = "Quote-module--quoteMarks--jfYN9";
export var right = "Quote-module--right--Bx+Pe";
export var separator = "Quote-module--separator--hv4L5";
export var text = "Quote-module--text--bHDsG";